// Configuration for risk detail fields and sections

export interface RiskFieldConfig {
  key: string;
  label: string;
  type?: 'text' | 'select' | 'tags' | 'date' | 'textarea' | 'controlcombobox' | 'assetscombobox' | 'singleuser';
  options?: any[];
  section: string;
  fullWidth?: boolean;
  readOnly?: boolean;
}

export function generateFieldConfig(menus, users: any[], isCreateMode: boolean = false): RiskFieldConfig[] {
  const fields: RiskFieldConfig[] = [];

  let items: RiskFieldConfig[] = [
    // Risk Description
    { key: 'risk', label: 'Event', section: 'Risk Description', type: 'textarea', fullWidth: false },
    { key: 'cause', label: 'Cause', section: 'Risk Description', type: 'textarea', fullWidth: true },
    { key: 'impact', label: 'Impact', section: 'Risk Description', type: 'textarea', fullWidth: true },

    // Initial / Inherent Risk
    { key: 'inherentLike', label: 'Inherent Likelihood', section: 'Initial / Inherent Risk', type: 'select', options: menus.inherentLike || [] },
    { key: 'inherentCons', label: 'Inherent Consequence', section: 'Initial / Inherent Risk', type: 'select', options: menus.inherentCons || [] },
    { key: 'consType', label: 'Consequence Type', section: 'Initial / Inherent Risk', type: 'select', options: menus.consType || [] },
    { key: 'inherentRisk', label: 'Overall / Inherent Risk Rating', section: 'Initial / Inherent Risk', type: 'select', options: menus.inherentRisk || [] },

    // Controls and Treatment
    {
      key: 'response',
      label: 'Response',
      section: 'Controls and Treatment',
      type: 'select',
      options: (menus.response || []).some(opt => opt.toLowerCase() === "treat".toLowerCase()) ? menus.response : [...(menus.response || []), "Treat"],
    },
    { key: 'reduction', label: 'Reduction', section: 'Controls and Treatment', type: 'select', options: ['Likelihood', 'Consequence'] },
    { key: 'selectedControls', label: 'Controls Implemented', section: 'Controls and Treatment', type: 'controlcombobox', fullWidth: true },
    { key: 'additionalControls', label: 'Additional Controls', section: 'Controls and Treatment', type: 'textarea', fullWidth: true },
    { key: 'controlEffect', label: 'Control Effectiveness', section: 'Controls and Treatment', type: 'select', options: menus.controlEffect || [] },
    { key: 'treatmentRequired', label: 'Treatment Required', section: 'Controls and Treatment', type: 'select', options: menus.treatRequired || [] },
    { key: 'treatmentPlan', label: 'Treatment Plan', section: 'Controls and Treatment', type: 'textarea', fullWidth: true },

    // Residual
    { key: 'targetRisk', label: 'Target Risk', section: 'Residual', type: 'select', options: menus.targetRisk || [] },
    { key: 'residualRisk', label: 'Residual Risk', section: 'Residual', type: 'select', options: menus.residualRisk || [] },

    // Risk Metadata (all remaining fields)
    { key: 'riskID', label: 'Risk ID', section: 'Risk Metadata', type: 'text', readOnly: true },
    { key: 'displayName', label: 'Risk Title', section: 'Risk Metadata', type: 'text', fullWidth: true },
    { key: 'riskCategory', label: 'Risk Category', section: 'Risk Metadata', type: 'select', options: menus.riskCategory || [] },
    { key: 'businessUnit', label: 'Business Unit', section: 'Risk Metadata', type: 'select', options: menus.businessUnit || [] },
    { key: 'riskOwner', label: 'Risk Owner', section: 'Risk Metadata', type: 'singleuser' },
    { key: 'lastReviewDate', label: 'Last Review Date', section: 'Risk Metadata', type: 'date' },
    { key: 'nextReviewDate', label: 'Next Review Date', section: 'Risk Metadata', type: 'date' },
    { key: 'assets', label: 'Related Assets', section: 'Risk Metadata', type: 'assetscombobox', fullWidth: true },
  ];

  return [...fields, ...items] as RiskFieldConfig[];
}
